function o(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
export {
  o as commonjsRequire
};
//# sourceMappingURL=index.es495.js.map
